export const isNumericString = (value: string): boolean => /^\d+$/.test(value);
